import { getAddress } from '../address/getAddress.js';
import { isAddressEqual } from '../address/isAddressEqual.js';
import { recoverMessageAddress } from './recoverMessageAddress.js';
export async function verifyMessage({ address, message, signature, }) {
    return isAddressEqual(getAddress(address), await recoverMessageAddress({ message, signature }));
}
//# sourceMappingURL=verifyMessage.js.map